export default "__VITE_ASSET__0bb89ce8__"